import React from 'react'

import { AccessibilityDeclarationMobileBase } from 'features/profile/pages/Accessibility/AccessibilityDeclarationMobileBase'
import { env } from 'libs/environment/env'

export function AccessibilityDeclarationMobileAndroid() {
  return (
    <AccessibilityDeclarationMobileBase
      appVersion="1.395.0"
      platformName="Android"
      osVersion="15"
      storeLink={{ url: `https://play.google.com/store/apps/details?id=${env.ANDROID_APP_ID}` }}
      auditDate="16/06/2026"
      conformityEN="79,59%"
      conformityRAAM="90,91%"
      averageConformityRAAM="97,67%"
      nonAccessibleContent={[
        'Critère 5.1.c - Chaque composant d’interface est-il, si nécessaire, compatible avec les technologies d’assistance\u00a0?',
        'Critère 5.4 - Dans chaque écran, les messages de statut sont-ils correctement restitués par les technologies d’assistance\u00a0?',
        'Critère 10.2 - Dans chaque écran, l’ordre de restitution par les technologies d’assistance est-il cohérent\u00a0?',
        'Critère 11.10 - Dans chaque écran, les fonctionnalités activables au moyen d’un geste complexe sont-elles activables au moyen d’un geste simple\u00a0?',
      ]}
      toolsUsed={[
        'TalkBack (lecteur d’écran)',
        'Switch Access (accès avec un périphérique externe)',
        'Paramètres de présentation utilisateurs (taille de police etc.)',
      ]}
    />
  )
}
